module.exports = __webpack_public_path__ + "static/media/logo2.2ce2face.png";